/** Nozzle meter opening/closing readings — 3 decimal places (litres). */
export const NOZZLE_READING_DECIMALS = 3;

export const toFixedNozzleReading = (value) => {
	const parsed = parseFloat(value);
	return Number.isFinite(parsed)
		? parsed.toFixed(NOZZLE_READING_DECIMALS)
		: (0).toFixed(NOZZLE_READING_DECIMALS);
};

export const preventNozzleReadingInput = (e, num) => {
	e = e || window.event;
	const charCode = typeof e.which === 'undefined' ? e.keyCode : e.which;
	const charStr = String.fromCharCode(charCode);
	const fullChar = num ? num.toString() + charStr : charStr;

	if (!/^\d*(\.\d{0,3})?$/.test(fullChar)) {
		e.preventDefault();
	}

	const [integerPart] = fullChar.split('.');
	if (integerPart.length > 8) {
		e.preventDefault();
	}
};
